const features = [
  {
    icon: 'ri-shield-flash-line',
    title: '匿名投稿保护',
    desc: '无需注册即可投稿，IP地址不可逆加密处理，我们从不追踪投稿者身份，确保每一条51爆料黑料的来源绝对保密。',
  },
  {
    icon: 'ri-timer-flash-line',
    title: '24小时不间断更新',
    desc: '黑料不打烊是我们的核心理念。无论深夜还是凌晨，只要有新瓜出现，第一时间为您奉上最热乎的51黑料爆料。',
  },
  {
    icon: 'ri-stack-line',
    title: '海量黑料大全',
    desc: '累计收录爆料超过5万条，覆盖娱乐、网红、商业、社会四大领域16个细分分类，是全网最全的黑料汇总平台。',
  },
  {
    icon: 'ri-check-double-line',
    title: '多渠道交叉验证',
    desc: '每一条负面爆料发布前均经过至少两个独立来源的交叉验证，标注可信度等级，让您吃得放心、吃得明白。',
  },
  {
    icon: 'ri-fire-line',
    title: '每日200+更新',
    desc: '每日新增爆料内容超过200条，涵盖内幕消息、明星黑历史、网红翻车、企业丑闻等各类热门话题，内容永不枯竭。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-12 md:py-16 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 text-center mb-8">
          本站优势
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {features.map((f, i) => (
            <div
              key={i}
              className="bg-background-100 rounded-lg p-5 border border-background-200/70 text-center hover:border-primary-200 transition-colors group"
            >
              <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-primary-100 flex items-center justify-center group-hover:bg-primary-500 transition-colors">
                <i className={`${f.icon} text-xl text-primary-500 group-hover:text-background-50 transition-colors`}></i>
              </div>
              <h3 className="text-sm md:text-base font-medium text-foreground-900 mb-2">{f.title}</h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}